export default __webpack_public_path__ + "static/12-45cefa74fdcfe16f379f7a10a96cd763.jpg";